export default "__VITE_ASSET__D1AAk9xZ__"